// one-time-code boxes.
import { digitsOnly } from '../rules.ts';
import { $$ } from './core.ts';

export function initOtp(): void {
  $$('.ds-otp').forEach(mountOtp);
}
/** One-time-code boxes inside .ds-otp[data-target][data-length]; the joined code goes into the target input. */
export function mountOtp(box: HTMLElement): void {
  {
    const target = document.getElementById(box.dataset.target!) as HTMLInputElement | null,
      n = +(box.dataset.length || 6);
    // no maxlength=1 on the cells: it cut a pasted or SMS-autofilled code down to its first digit
    box.innerHTML = Array.from(
      { length: n },
      (_, i) =>
        `<input inputmode="numeric" maxlength="${n}" aria-label="رقم ${i + 1}" autocomplete="${i ? 'off' : 'one-time-code'}">`,
    ).join('');
    const cells = $$<HTMLInputElement>('input', box),
      sync = (): void => {
        if (target) {
          target.value = cells.map(c => c.value).join('');
          target.dispatchEvent(new Event('input', { bubbles: true }));
        }
      };
    // several digits at once (paste, autofill): a whole code fills from the first box, a part from the current one
    const spread = (d: string, i: number): void => {
      const from = d.length >= n ? 0 : i;
      // eslint-disable-next-line @typescript-eslint/no-misused-spread -- the string holds digits only
      [...d.slice(0, n - from)].forEach((ch, k) => {
        cells[from + k].value = ch;
      });
      cells[Math.min(n - 1, from + d.length - 1)].focus();
      sync();
    };
    cells.forEach((c, i) => {
      c.addEventListener('paste', e => {
        const d = digitsOnly(e.clipboardData?.getData('text') || '');
        if (!d) return;
        e.preventDefault();
        spread(d, i);
      });
      c.addEventListener('input', () => {
        const d = digitsOnly(c.value);
        if (d.length > 1) {
          c.value = '';
          spread(d, i);
          return;
        }
        c.value = d;
        if (d && i < n - 1) cells[i + 1].focus();
        sync();
      });
      c.addEventListener('keydown', e => {
        if (e.key === 'Backspace' && !c.value && i > 0) cells[i - 1].focus();
      });
    });
  }
}
